import CSRFTokenResolver from "../global/CSRFTokenResolver";

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': CSRFTokenResolver.getToken(),
    'X-Requested-With': 'XMLHttpRequest'
};

import SplitType from 'split-type';
import dragscroll from 'dragscroll';
import imagesLoaded from 'imagesloaded';
import UAParser from 'ua-parser-js';

$(document).ready(function() {
    let exhibitorsSlider,
        target = $('.bb-popup.open').attr('id') ? '#' + $('.bb-popup.open').attr('id') : null;
    
    $('#lobby-content').imagesLoaded().always(function(instance) {
        $('a.hotspot').each(function(index, element) {
            window.setTimeout(function() {
                $(element).addClass('visible');
            }, 500);
        });

        let _scrollTop = $('.lobby-wrapper').prop('scrollHeight') || $(window).height();
        let _scrollLeft = (($('.lobby-wrapper').prop('scrollWidth') - $(window).width()) / 2) + 32;
        
        $('.lobby-wrapper').scrollTop(_scrollTop);
        $('.lobby-wrapper').scrollLeft(_scrollLeft);
    });

    let iframeInitialised = false,
        galleryInitialised = false;

    $(document).on('click', '#expand-menu', function(event) {
        event.preventDefault();

        var timeline = anime.timeline({
            easing: 'easeInOutQuad',
            duration: 500,
            direction: 'normal'
        });

        timeline.add({
            targets: '#side-nav .navigation-content',
            opacity: [1, 0],
            duration: 250,
            delay: 0,
            complete: function(anim) {
                $('#side-nav').css('display', 'none');
            }
        }).add({
            targets: '#side-nav-expanded',
            width: ['0px', '492px'],
            duration: 350,
            begin: function(anim) {
                anim.animatables.forEach(function(item) {
                    item.target.style.display = 'block';
                });
            }
        }, '-=50').add({
            targets: '#side-nav-expanded .navigation-content',
            opacity: [0, 1],
            duration: 300,
            begin: function(anim) {
                anim.animatables.forEach(function(item) {
                    item.target.style.display = 'block';
                });
            }
        }, '-=50');

        anime({
            targets: '.lobby-content',
            paddingLeft: '492px',
            easing: 'easeInOutQuad',
            duration: 500,
            delay: 50
        });

        anime({
            targets: '.bb-popup',
            left: '492px',
            easing: 'easeInOutQuad',
            duration: 500,
            delay: 50
        });

        $('.lobby-home').addClass('expanded');
        localStorage.setItem('sideMenu', 'false');
    });
    
    $(document).on('click', '#collapse-menu', function(event) {
        event.preventDefault();

        var timeline = anime.timeline({
            easing: 'easeInOutQuad',
            direction: 'normal'
        });
        
        timeline.add({
            targets: '#side-nav-expanded .navigation-content',
            opacity: 0,
            duration: 250,
            begin: function(anim) {
                anim.animatables.forEach(function(item) {
                    item.target.style.display = 'block';
                });
            },
            complete: function(anim) {
                anim.animatables.forEach(function(item) {
                    item.target.style.display = 'none';
                });
            }
        }).add({
            targets: '#side-nav-expanded',
            width: '0px',
            duration: 350,
            begin: function(anim) {
                anim.animatables.forEach(function(item) {
                    item.target.style.display = 'block';
                });
            },
            complete: function(anim) {
                anim.animatables.forEach(function(item) {
                    item.target.style.display = 'none';
                });
            }
        }, '-=75').add({
            targets: '#side-nav .navigation-content',
            opacity: [0, 1],
            duration: 350,
            delay: 0,
            begin: function(anim) {
                $('#side-nav').css('display', 'block');
            }
        }, '-=50');

        var width = $('#side-nav').width();

        anime({
            targets: '.lobby-content',
            paddingLeft: width + 'px',
            easing: 'easeInOutQuad',
            duration: 500,
            delay: 50
        });

        anime({
            targets: '.bb-popup',
            left: width + 'px',
            easing: 'easeInOutQuad',
            duration: 500,
            delay: 50
        });

        $('.lobby-home').removeClass('expanded');
        localStorage.setItem('sideMenu', 'true');
    });

    $(document).on('click', '.accordion-item', function(event) {
        event.preventDefault();

        $('.accordion-body').slideUp();
        $(this).find('.accordion-body').slideDown(300);
        $('.accordion-item').removeClass('active');
        $(this).addClass('active');
    });

    $(document).on('click', '.close-aside', function(event) {
        event.preventDefault();
        let target = $(this).parent().parent().parent().attr('id');

        if ($(this).parent().parent().parent().hasClass('visible')) {
            anime({
                targets: '#' + target,
                right: '-100%',
                easing: 'easeInExpo',
                duration: 500,
                complete: function (anim) {
                    for (var i = 0; i < anim.animatables.length; i++) {
                        anim.animatables[i].target.style.display = 'none';
                        anim.animatables[i].target.classList.remove('visible');
                    }
                }
            });
        }
    });

    let _isMouseDown = false,
        _startX,
        _scrollLeft;

    $('.tours-wrapper .tours-scroll').each((index, element) => {
        if ($(element).prop('scrollWidth') > $(element).width()) {
            if ($(element).prop('scrollLeft') > 5) {
                $(element).parent().addClass('scroll-start');
            }

            if (($(element).prop('scrollLeft') + $(element).width()) >= $(element).prop('scrollWidth')) {
                $(element).parent().addClass('scroll-end');
            }
        }

        var tabsList = element;

        $(element).parent().find('.nav-prev').on('mousedown', function(event) {
            event.preventDefault();
            $(tabsList).animate({
                scrollLeft: $(tabsList).prop('scrollLeft') - (Math.floor(($('.tours-wrapper').width() + 120) / ($('.tour-item').width() + 16)) * ($('.tour-item').width() + 16))
            }, 350);
        });
        
        $(element).parent().find('.nav-next').on('mousedown', function(event) {
            event.preventDefault();
            $(tabsList).animate({
                scrollLeft: $(tabsList).prop('scrollLeft') + (Math.floor(($('.tours-wrapper').width() + 120) / ($('.tour-item').width() + 16)) * ($('.tour-item').width() + 16))
            }, 350);
        });
    });

    $('.tours-wrapper .tours-scroll').on('scroll', function(event) {
        if ($(this).prop('scrollLeft') < 5) {
            $(this).parent().removeClass('scroll-end');
            $(this).parent().addClass('scroll-start');
        } else if (($(this).prop('scrollLeft') + $(this).width() + 125) >= $(this).prop('scrollWidth')) {
            $(this).parent().removeClass('scroll-start');
            $(this).parent().addClass('scroll-end');
        } else {
            $(this).parent().addClass('scroll-start');
            $(this).parent().addClass('scroll-end');
        }
    });

    $('.tours-wrapper .tours-scroll').on('mousedown', function(event) {
        _isMouseDown = true;
        _startX = event.pageX - $('.tours-wrapper .tours-scroll').offset().left;
        _scrollLeft = $('.tours-wrapper .tours-scroll').scrollLeft();
    });
    
    $('.tours-wrapper .tours-scroll').on('mouseleave', function(event) {
        _isMouseDown = false;
    });
    
    $('.tours-wrapper .tours-scroll').on('mouseup', function(event) {
        _isMouseDown = false;
    });

    $('.tours-wrapper .tours-scroll').on('mousemove', function(event) {
        event.preventDefault();
        if (!_isMouseDown) return;
        else event.stopPropagation();
        let _x = event.pageX - $('.tours-wrapper .tours-scroll').offset().left;
        let _walk = _x - _startX;
        $('.tours-wrapper .tours-scroll').scrollLeft(_scrollLeft - _walk);
    });

    $(document).on('click', 'a.latest-news-btn', function(event) {
        event.preventDefault();
        let _target = event.target.getAttribute('href');

        if (_target) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(_target).offset().top
            }, 750);
        }
    });

    function openPopup(popupId, delay) {
        anime({
            targets: popupId,
            translateX: ['-101%', '0%'],
            duration: 750,
            easing: 'easeOutExpo',
            delay: delay ? delay : 0,
            begin: function(anim) {
                for (var i = 0; i < anim.animatables.length; i++) {
                    anim.animatables[i].target.style.display = 'block';
                }
            },
            complete: function(anim) {
                for (var i = 0; i < anim.animatables.length; i++) {
                    anim.animatables[i].target.classList.add('visible');
                    anim.animatables[i].target.style.display = 'block';
                    // Splits text into words and characters
                    // $('#issue-brochure h1').css('overflow: hidden;');
                    const heading = new SplitType('#issue-brochure h1', {
                        types: 'chars',
                        absolute: true
                    });

                    anime({
                        targets: heading.chars,
                        opacity: [0, 1],
                        translateY: [20, 0],
                        duration: 240,
                        easing: 'easeOutExpo',
                        delay: anime.stagger(20)
                    });

                    if (popupId === '#exhibitors-popup' || popupId.indexOf('exhibitors-popup') !== -1) {
                        exhibitorsSlider = new Swiper('.exhibitors-slider', {
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            },
                        });
                    }
                }
            }
        });
    }

    function closePopup(popupId) {
        anime({
            targets: popupId,
            translateX: '-100%',
            easing: 'easeInExpo',
            duration: 500,
            complete: function(anim) {
                for (var i = 0; i < anim.animatables.length; i++) {
                    anim.animatables[i].target.style.display = 'none';
                    anim.animatables[i].target.classList.remove('visible');
                }

                if (popupId === '#exhibitors-popup' || popupId.indexOf('exhibitors-popup') !== -1) {
                    if (exhibitorsSlider) {
                        exhibitorsSlider.destroy();
                        exhibitorsSlider = undefined;
                    }
                }
            }
        });
    }

    $(document).on('click', '.open-modal', function(event) {
        event.preventDefault();
        let _delay = 0;

        if (target && target !== event.target.getAttribute('href')) {
            closePopup(target);
            _delay = 500;
        }

        target = event.target.getAttribute('href') && event.target.getAttribute('href')[0] == '#' ? event.target.getAttribute('href') : event.target.getAttribute('data-target');
        
        if ($(target).hasClass('visible')) {
            return;
        }

        openPopup(target, _delay);
    });

    $(document).on('click', '.close-popup', function(event) {
        event.preventDefault();

        closePopup(target);
    });

    $(document).on('click', '.btn-3d-tour', function(event) {
        event.preventDefault();

        let delay = 0;

        if ($('#popup-3d-tours').hasClass('visible')) {
            return;
        }

        if (target && target.length > 0) {
            if (target != '#popup-3d-tours') {
                delay = 500;
                closePopup(target);
            }
        }

        target = '#popup-3d-tours';

        let _memberId = $('a.btn-tour__card.active').data('id') || $('a.btn-tour__card').first().data('id');
        axios.post('/matterport/' + _memberId);

        anime({
            targets: '#popup-3d-tours',
            translateX: ['-102%', '0%'],
            duration: 750,
            easing: 'easeOutExpo',
            delay: delay,
            begin: function(anim) {
                for (var i = 0; i < anim.animatables.length; i++) {
                    anim.animatables[i].target.style.display = 'block';
                }

                if (iframeInitialised) {
                    $('#popup-3d-tours iframe').attr('src', $('#popup-3d-tours iframe').attr('data-src'));
                }

                if (!galleryInitialised) {
                    if ($('.tours-wrapper .tours-scroll').width() < $('.tours-wrapper .tours-scroll').prop('scrollWidth')) {
                        if ($('.tours-wrapper .tours-scroll').prop('scrollLeft') < 5) {
                            $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-end');
                            $('.tours-wrapper .tours-scroll').parent().addClass('scroll-start');
                        } else if (($('.tours-wrapper .tours-scroll').prop('scrollLeft') + $('.tours-wrapper .tours-scroll').width() + 5) >= $('.tours-wrapper .tours-scroll').prop('scrollWidth')) {
                            $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-start');
                            $('.tours-wrapper .tours-scroll').parent().addClass('scroll-end');
                        } else {
                            $('.tours-wrapper .tours-scroll').parent().addClass('scroll-start');
                            $('.tours-wrapper .tours-scroll').parent().addClass('scroll-end');
                        }
                    } else {
                        $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-start');
                        $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-end');
                    }
                    galleryInitialised = true;
                }
            },
            complete: function(anim) {
                for (var i = 0; i < anim.animatables.length; i++) {
                    anim.animatables[i].target.classList.add('visible');
                    anim.animatables[i].target.style.display = 'block';
                }

                // Splits text into words and characters
                const heading = new SplitType('#popup-3d-tours h1', {
                    types: 'chars',
                    absolute: true
                });

                anime({
                    targets: heading.chars,
                    opacity: [0, 1],
                    translateY: [20, 0],
                    duration: 240,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(20)
                });
            }
        });
    });
    
    $('#close-3d-tours').click(function(event) {
        event.preventDefault();

        anime({
            targets: '#popup-3d-tours',
            translateX: '-100%',
            easing: 'easeInExpo',
            duration: 500,
            complete: function(anim) {
                for (var i = 0; i < anim.animatables.length; i++) {
                    anim.animatables[i].target.style.display = 'none';
                    anim.animatables[i].target.classList.remove('visible');
                }

                if (iframeInitialised) {
                    $('#popup-3d-tours iframe').attr('src', '');
                }
            }
        });
    });

    $('a.btn-tour__card').click(function(event) {
        event.preventDefault();
        event.stopPropagation();

        $('a.btn-tour__card').removeClass('active');
        $(this).addClass('active');

        let _src = $(this).data('src').trim();
        $('#popup-3d-tours iframe').attr('src', _src);
        $('#popup-3d-tours iframe').attr('data-src', _src);

        let _memberId = $(this).data('id');
        axios.post('/matterport/' + _memberId);
    });

    $('.tours-wrapper').imagesLoaded()
        .progress(function(instance, image) {
            if (!image.isLoaded) {
                $(image.img).closest('.tour-item').remove();
            }
        })
        .always(function(instance) {
            $('a.btn-tour__card').first().addClass('active');
            $('#popup-3d-tours iframe').attr('data-src', $('a.btn-tour__card').first().data('src'));
        });

    $('#popup-3d-tours iframe').removeAttr('width');
    $('#popup-3d-tours iframe').removeAttr('height');
    $('#popup-3d-tours iframe').css('width', '100%');
    $('#popup-3d-tours iframe').css('height', '100%');
    iframeInitialised = true;

    const newsSlider = new Swiper('.news-slider', {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
    });

    let _addressDropdownInitialised;
    let ua = new UAParser();

    let isMobile = ua.getDevice().type === 'mobile' || ua.getDevice().type === 'tablet';

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('#enter-manually').click(function () {
        $('#address-wrapper').show();
    });
    $('#postcode-search').keypress(function (e) {
        if (e.which === 13) {
            searchPostcode();
            return false;
        }
    });
    $('#search-postcode').click(function () {
        searchPostcode()
    });
    $('#select-address').change(function () {
        $.ajax({
                method: 'get',
                url: '/api/v1/loqate/retrieve',
                data: {
                    address_id: $(this).val()
                },
                dataType: 'json'
            })
            .done(function (data) {
                if (data.success) {
                    $('#contact-details-address-line-1').val(data.data['address_line_1']);
                    let addressLine2 = data.data['address_line_2'];
                    if (addressLine2 !== '') {
                        addressLine2 += ', ' + data.data['address_line_2'];
                    } else {
                        addressLine2 = data.data['city'];
                    }
                    $('#contact-details-address-line-2').val(addressLine2);
                    $('#contact-details-postcode').val(data.data['postcode']);
                    $('#address-wrapper').show();
                    $('#enter-manually').hide();
                }
            });
    });

    function searchPostcode() {
        if (_addressDropdownInitialised) {
            $('#select-address')[0].selectize.destroy();
            _addressDropdownInitialised = false;
        }

        let postcode = $('#postcode-search').val();
        if (postcode === '') return;
        $.ajax({
            method: 'get',
            url: '/api/v1/loqate/find',
            data: {
                search: postcode
            },
            dataType: 'json'
        })
        .done(function (data) {
            if (data.success) {

                let message = 'Select an address...';

                if (!data.items.length) {
                    message = 'No addresses found, search again or enter manually'
                }

                let html = '<option value="" selected disabled>' + message + '</option>';
                data.items.forEach(function (item) {
                    html += '<option value="' + item['Id'] + '">' + item['Text'] + ', ' + item['Description'] + '</option>';
                });
                $('#select-address').html(html);
                if (!isMobile) {
                    $('#select-address').selectize();
                    _addressDropdownInitialised = true;
                }
                $('#select-address-wrapper').show();
            }
        });
    }

    if (target && typeof target == 'string') {
        openPopup(target, 0);
    }
});